export function createFukushizaiContextColorService(deps) {
    // 指定 context の color 一覧を rows から重複なしで拾います。
    function contextColorCodesFromRows(rows, itemCd, groupNo, panelType = "") {
        const seen = new Set();
        const out = [];
        (Array.isArray(rows) ? rows : []).forEach((row) => {
            if (!deps.rowMatchesFukushizaiItemGroup(row, itemCd, groupNo)) return;
            if (panelType !== "" && deps.isInvalidDisplayRow(row, panelType)) return;
            const colorCd = deps.readFukushizaiItemGroupFromAnyRow(row).colorCd;
            if (colorCd === "" || seen.has(colorCd)) return;
            seen.add(colorCd);
            out.push(colorCd);
        });
        return out;
    }

    // 登録グループ表示行から color 一覧を返します。
    function registeredColorCodesForContext(itemCd, groupNo) {
        return contextColorCodesFromRows(
            deps.resolveRegisteredGroupRows(),
            itemCd,
            groupNo,
            deps.PANEL_TYPE.REGISTERED_GROUP
        );
    }

    // 副資材 context に紐づく color 一覧を、base → registered group → quality の順に解決します。
    function fukushizaiColorCodesForContext(itemCd, groupNo) {
        const colors = contextColorCodesFromRows(
            deps.getDetailRowsByPanelType(deps.entrydetailRef.current, deps.FUKUSHIZAI_BASE_PANEL_TYPE),
            itemCd,
            groupNo,
            deps.FUKUSHIZAI_BASE_PANEL_TYPE
        );
        if (colors.length !== 0) return colors;

        const registeredColors = registeredColorCodesForContext(itemCd, groupNo);
        if (registeredColors.length !== 0) return registeredColors;

        const seen = new Set();
        deps.QUALITY_DISPLAY_PANEL_TYPES.forEach((panelType) => {
            contextColorCodesFromRows(
                deps.getDetailRowsByPanelType(deps.entrydetailRef.current, panelType),
                itemCd,
                groupNo,
                panelType
            ).forEach((colorCd) => seen.add(colorCd));
        });
        return [...seen];
    }

    // group 複写時に target 側で適用すべき color 一覧を返します。
    function getFukushizaiCopyTargetColorCodes(itemCd, groupNo) {
        const colors = fukushizaiColorCodesForContext(itemCd, groupNo);
        if (colors.length !== 0) return colors;
        const contextColor = deps.normalizeColorCd(deps.selectedFukushizaiContextRef.current?.colorCd);
        return contextColor === "" ? [] : [contextColor];
    }

    // group copy の target context を正規化して返します。
    function resolveFukushizaiGroupCopyTargetContext(targetItem, targetGroup, sourceItem, sourceGroup) {
        const selectedItem = deps.normalizeItemCd(targetItem);
        const selectedGroupNo = deps.normalizeGroupNo(targetGroup);
        const copySourceItem = deps.normalizeItemCd(sourceItem);
        const copySourceGroup = deps.normalizeGroupNo(sourceGroup);
        if (selectedItem === "" || selectedGroupNo === "" || copySourceItem === "" || copySourceGroup === "") {
            return deps.createEmptyFukushizaiContext();
        }
        return { itemCd: selectedItem, groupNo: selectedGroupNo, colorCd: "" };
    }

    // group copy 用の source rows を panel 単位で返します。
    function sourceRowsForCopy(panelType, itemCd, groupNo) {
        return (deps.getDetailRowsByPanelType(deps.entrydetailRef.current, panelType) || [])
            .filter((row) => deps.rowMatchesFukushizaiItemGroup(row, itemCd, groupNo))
            .filter((row) => !deps.isInvalidDisplayRow(row, panelType));
    }

    return {
        contextColorCodesFromRows,
        registeredColorCodesForContext,
        fukushizaiColorCodesForContext,
        getFukushizaiCopyTargetColorCodes,
        resolveFukushizaiGroupCopyTargetContext,
        sourceRowsForCopy
    };
}
